import Game from "Game";
import { isNative } from "Utility/Platform";

export function queuePreloadAssets() {
  Game.resource.add("styles", "resource/data/styles.json");
  Game.resource.add("harvest_particle_data", "resource/data/particles/flow_up.json");
  Game.resource.add("crop_unlock_particle_data", "resource/data/particles/crops_rain.json");
  Game.resource.add("fireworks", "resource/data/particles/new_fireworks.json");
  Game.resource.add("fireworks-atlas", "resource/graphics/particles/fireworks.json");
  Game.resource.addIfNeeded(
    `free_lvl_spend_skeleton_data`,
    `resource/dragonbones/FreeLvl/free_lvl_spend_ske.json`
  );
  Game.resource.addIfNeeded(`free_lvl_spend_texture`, `resource/dragonbones/FreeLvl/free_lvl_spend_tex.png`);
  Game.resource.addIfNeeded(
    `free_lvl_spend_texture_data`,
    `resource/dragonbones/FreeLvl/free_lvl_spend_tex.json`
  );
  // Cards Rewards VFX.
  Game.resource.add("RewardEffect", "resource/graphics/sprite_sheets/reward.json");
  Game.resource.add("atlas-package_1", "resource/graphics/sprite_sheets/package_1.json");
  Game.resource.add("inLevelUnlockSettings", "resource/data/settings/inLevelUnlocks.json");
  Game.resource.add("blank", "resource/graphics/other/blank.png");
  Game.resource.add("harvest_ftux_overlay", "resource/graphics/other/fue_shadown.png");

  // Event data
  Game.resource.add("events", "resource/data/events/events.json");

  if (isNative()) {
    Game.resource.add(
      "atlas-savestate_select_popup",
      "resource/graphics/sprite_sheets/savestate_select_popup.json"
    );
  }
}
